var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['rounded-full font-medium', _vm.paddingX, _vm.paddingY],attrs:{"disabled":_vm.disabled},on:{"click":function (e) { return _vm.$emit('click', e); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }